import React from "react";
import ContactForm from "../../../components/ContactForm";

const ContactFormSection = () => {
    return(
        <section className="width py-8 lg:py-9">
            <ContactForm/>
        </section>
    )
}

export default ContactFormSection;